import { Outlet, useNavigate } from 'react-router-dom';
import { NavigationBar } from '../../shared/components/NavigationBar';
import { useOnboardingStore } from './hooks/useOnboardingStore';

export const OnBoardingLayout = () => {
    const navigate = useNavigate();
    const currentStep = useOnboardingStore((state) => state.currentStep);
    const totalSteps = useOnboardingStore((state) => state.totalSteps);

    const onBack = currentStep !== undefined ? () => {
        navigate(-1);
    } : undefined;

    return (
        <div className='w-full h-svh overflow-hidden flex flex-col'>
            <div className='mb-8'>
                {currentStep !== undefined && currentStep > 2 && <NavigationBar
                    onBack={onBack}
                    currentStep={currentStep}
                    totalSteps={totalSteps}
                />
                }
            </div>
            <Outlet />
        </div>
    );
};
